import { SearchBaseModel } from '../commonModels';

export class AlertSearchModel extends SearchBaseModel{

  constructor() {
    super();

    this.GarageId = null;
    this.CustomerId = null;
    this.OrderTypeId = null;
    this.Garage = null;
    this.Customer = null;
    this.IsActice = null;
    this.AddedByUser = null;
    this.DisactivatedByUser = null;
    this.Order = null;
    this.AddDateFrom = null;
    this.AddDateTo = null;
    this.DisactivatedDateFrom = null;
    this.DisactivatedDateTo = null;
    this.Title = null;
    this.Text = null;
    this.IsAllAlertVisible = null;
    this.RegistrationNumber = null;
    this.IsGuardianFilterOn = null;
  }


  public GarageId: number;

  public CustomerId: number;

  public OrderTypeId: number;

  public Garage: string;

  public Customer: string;

  public IsActice: boolean;

  public AddedByUser: string;

  public DisactivatedByUser: string;

  public Order: string;

  public AddDateFrom: Date;

  public AddDateTo: Date;

  public DisactivatedDateFrom: Date;

  public DisactivatedDateTo: Date;

  public Title: string;

  public Text: string;

  public IsAllAlertVisible: boolean;
    
  public RegistrationNumber: string;

  public IsGuardianFilterOn: boolean;
}
